import { passwordLengthOk } from "@divespots/contracts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { changePassword } from "../../auth/auth-api.ts";
import { Button } from "../../components/Button.tsx";
import { failureText } from "./messages.ts";
import { PasswordField } from "./PasswordField.tsx";

/** Account page: current password + new password twice. The other sessions end; the page says so. */
export function ChangePasswordForm() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setError(null);
    setDone(false);
    if (!current) return setError(t("diver.password.currentMissing"));
    if (!passwordLengthOk(password)) return setError(t("diver.auth.lengthInvalid"));
    if (password !== repeat) return setError(t("diver.auth.mismatch"));
    setBusy(true);
    const res = await changePassword(current, password);
    setBusy(false);
    if (!res.ok) {
      return setError(
        res.reason === "invalid" ? t("diver.password.currentWrong") : failureText(t, res),
      );
    }
    setCurrent("");
    setPassword("");
    setRepeat("");
    setDone(true);
  };

  return (
    <form
      className="grid gap-3"
      noValidate
      aria-label={t("diver.password.title")}
      onSubmit={(e) => {
        e.preventDefault();
        void submit();
      }}
    >
      <p className="ds-text-subheadline text-label-secondary m-0">{t("diver.password.lead")}</p>
      <PasswordField
        label={t("diver.password.current")}
        autoComplete="current-password"
        value={current}
        onChange={setCurrent}
      />
      <PasswordField
        label={t("diver.auth.newPassword")}
        autoComplete="new-password"
        value={password}
        onChange={setPassword}
        lengthCheck
      />
      <PasswordField
        label={t("diver.auth.repeatPassword")}
        autoComplete="new-password"
        name="new-password-repeat"
        value={repeat}
        onChange={setRepeat}
      />
      {error ? (
        <p className="adm-error m-0" role="alert">
          {error}
        </p>
      ) : null}
      <div className="adm-actions">
        <Button type="submit" variant="filled" disabled={busy}>
          {t("diver.password.submit")}
        </Button>
        {done ? (
          <p className="adm-ok m-0" role="status">
            {t("diver.password.done")}
          </p>
        ) : null}
      </div>
    </form>
  );
}
